import $ from 'jquery'
import tippy from 'tippy.js'

$(() => {
  tippy('[data-tippy-content]', {
    allowHTML: true,
    interactive: true,
  })
})
